import { render, staticRenderFns } from "./GuidedModeCompletionPrompt.vue?vue&type=template&id=454b82fa"
import script from "./GuidedModeCompletionPrompt.vue?vue&type=script&lang=ts"
export * from "./GuidedModeCompletionPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports